export enum PortTariffLineExpenseCategories {
  PORT = 'port',
  STEVEDORING = 'stevedoring',
  AGENCY = 'agency',
}
